@if (footerSlot$ | async; as slot) {
  @defer {
    <section
      [attr.position]="slot?.position"
      [class]="slot?.position"
      [class.has-components]="slot?.components?.component?.length"
      [boelsSlotDecorator]="slot?.properties"
    >
      @if (slot?.components?.component?.[0]; as context) {
        <boels-footer-navigation
          [data$]="componentData$"
          [boelsSlotDecorator]="context?.properties"
        ></boels-footer-navigation>
      }
    </section>
  }
}
